import React, { useEffect } from "react";
import {
  MapContainer,
  TileLayer,
  GeoJSON,
  LayersControl,
  useMap,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// Fix for default icon issue with webpack
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

interface GisMapProps {
  properties: any[];
  style?: React.CSSProperties;
}

function SetViewToBounds({ geoJsonData }: { geoJsonData: any[] }) {
  const map = useMap();
  useEffect(() => {
    if (geoJsonData && geoJsonData.length > 0) {
      const group = new L.FeatureGroup();
      geoJsonData.forEach((feature: any) => {
        if (feature) {
          const layer = L.geoJSON(feature);
          group.addLayer(layer);
        }
      });
      const bounds = group.getBounds();
      if (bounds.isValid()) {
        map.fitBounds(bounds);
      }
    }
  }, [geoJsonData, map]);

  return null;
}

const GisMap: React.FC<GisMapProps> = ({ properties, style }) => {
  const geoJsonData = properties
    .map((p) => {
      if (p.geometry) {
        try {
          const geom = JSON.parse(p.geometry);
          return {
            type: "Feature",
            properties: {
              ...p,
            },
            geometry: geom,
          };
        } catch (e) {
          console.error("Error parsing geometry", e);
          return null;
        }
      }
      return null;
    })
    .filter((f) => f !== null);

  return (
    <MapContainer
      center={[51.505, -0.09]}
      zoom={13}
      style={style || { height: "500px", width: "100%" }}
    >
      <LayersControl position="topright">
        <LayersControl.BaseLayer checked name="Street">
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          />
        </LayersControl.BaseLayer>
        <LayersControl.BaseLayer name="Satellite">
          <TileLayer
            url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
            attribution="&copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community"
          />
        </LayersControl.BaseLayer>
      </LayersControl>
      {geoJsonData.map((feature: any, index: number) => (
        <GeoJSON key={index} data={feature} />
      ))}
      <SetViewToBounds geoJsonData={geoJsonData} />
    </MapContainer>
  );
};

export default GisMap;
